import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "../styles/homescreen.css";
import "../styles/highlightsection.css";
import CategoriesList from "../components/Categories";
import InternationalSection from "../components/International";
import Feedbacks from "../components/Feedbacks";
import LoadingPage from "../components/Loading";
import EventCell from "../components/EventCell";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTopEventsData,
  fetcHighlightData,
  fetchUpcommingEvents,
} from "../features/events/events_slice";

function Homescreen() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const topEventsData = useSelector((state) => state.events.topEventsData);
  const highlightData = useSelector((state) => state.events.highlightData);
  const upcommingData = useSelector(
    (state) => state.events.upcommingEventsData
  );
  const highlightLoading = useSelector(
    (state) => state.events.highlightLoading
  );
  const topEventsLoading = useSelector(
    (state) => state.events.topEventsLoading
  );
  const upcommingLoading = useSelector(
    (state) => state.events.upcommingLoading
  );

  useEffect(() => {
    if (topEventsLoading) dispatch(fetchTopEventsData());
    if (highlightLoading) dispatch(fetcHighlightData());
    if (upcommingLoading) dispatch(fetchUpcommingEvents());
  }, [dispatch, topEventsLoading, highlightLoading, upcommingLoading]);

  useEffect(() => {
    const savedScroll = sessionStorage.getItem("categoryScroll");

    if (savedScroll) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScroll));
      }, 0);
    }
  }, []);

  if (topEventsData.length === 0) {
    return <LoadingPage />;
  }

  return (
    <div>
      <div className="carousel">
        <Swiper
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Pagination, Autoplay]}
          loop={true}
          className="swiper"
        >
          {topEventsData.map((item) => (
            <SwiperSlide key={item.created_date + "topEventsData"}>
              <div className="image-container">
                <img
                  src={item.main_image}
                  alt={`Slide ${item.created_date + 1}`}
                  className="image-container"
                />
                <div className="carousel-text-container">
                  <h3 className="carousel-subtitle">{item.sub_title}</h3>
                  <h1 className="carousel-title">{item.title}</h1>
                  <div className="faded-divider"></div>
                  <div className="price-text-container">
                    <span className="price-text-left">Starting at</span>
                    <span className="price-text">
                      ₹ {Number(item.price).toLocaleString()}
                    </span>
                  </div>
                  <button
                    onClick={() =>
                      navigate(
                        `/${item.event_type}/${item.id}/${item.title.replace(
                          / /g,
                          "-"
                        )}`,
                        {
                          state: { passedData: item },
                        }
                      )
                    }
                    className="rect-button"
                  >
                    View More
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {upcommingData.length !== 0 ? (
        <>
          <h2 className="section-title">Ongoing Events</h2>
          <div className="highlight-carousel">
            <Swiper
              className="upcomming-swiper"
              pagination={{ clickable: true }}
              modules={[Pagination, Navigation]}
              navigation
              spaceBetween={8}
              loop={true}
              // slidesPerView={4}
              breakpoints={{
                750: { slidesPerView: 4 },
                0: { slidesPerView: 1.5 },
              }}
            >
              {upcommingData.map((item) => (
                <SwiperSlide key={item.created_date + "Upcomming"}>
                  <EventCell item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="upcomming-swiper-pagination"></div>
        </>
      ) : (
        <></>
      )}
      <h2 className="section-title">Winter Holiday Special</h2>
      <InternationalSection section={"winter_holiday_special"} />
      <h2 className="section-title">Top Events</h2>
      <div className="highlight-carousel">
        <Swiper
          className="highlight-swiper"
          pagination={{ clickable: true }}
          modules={[Pagination, Navigation]}
          navigation
          spaceBetween={8}
          loop={true}
          // slidesPerView={4}
          breakpoints={{
            750: { slidesPerView: 4 },
            0: { slidesPerView: 1.5 },
          }}
        >
          {highlightData.map((item) => (
            <SwiperSlide key={item.created_date + "highlightData"}>
              <EventCell item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="highlight-swiper-pagination"></div>
      <section>
        <h2 className="section-title">Categories</h2>
        <CategoriesList />
      </section>
      <h2 className="section-title">International</h2>
      <InternationalSection section={"international"} />
      <h2 className="section-title">Himalayan</h2>
      <InternationalSection section={"himalayan"} />
      <h2 className="section-title">Feedbacks</h2>
      <Feedbacks />
    </div>
  );
}

export default Homescreen;
